import { useCallback } from "react";
import { useStickyTourStore } from "../../stores/stickyTourStore";
import { useSudowriteStore } from "../../stores/sudowriteStore";
import { FIND_TOUR_AGAIN_TOUR } from "./Tours/FindTourAgain";
import { TourIds } from "./TourTypes";

export function useExitTour() {
  const endTour = useStickyTourStore((state) => state.endTour);
  const startTour = useStickyTourStore((state) => state.startTour);
  const activeTourId = useStickyTourStore((state) => state.activeTourId);
  const userData = useSudowriteStore((state) => state.userData);

  return useCallback(() => {
    if (activeTourId === TourIds.WRITE_REWRITE || activeTourId === TourIds.PLUGINS_QUICKSTART || activeTourId === TourIds.FEEDBACK) {
      userData?.update({ needsDemo: false });
    }

    endTour(true);
    // The paragraph spacing tour is not replayable from the Help menu, so
    // do not point users there after they exit it.
    if (activeTourId !== TourIds.PLUGINS_QUICKSTART && activeTourId !== TourIds.PARAGRAPH_SPACING) {
      startTour(FIND_TOUR_AGAIN_TOUR);
    }
  }, [activeTourId, endTour, startTour, userData]);
}
